import { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { message } from "antd";
import Button from "../../components/button";
import InputLabel from "../../components/inputLabel";
import PageTitle from "../../components/pageTitle";
import { LoginForm, LoginWrapper, LinkSecundario } from "./styled";
import loginActions from "../../redux/login/actions";
import { useNavigate } from "react-router-dom";
import routes from "../../routes/routes.path";
import { ConfigsSet, getSessionConfig } from "../../utils/session-helper";
import ModalLGPD from "../../components/modalLGPD";
import { StoreState } from "../../redux/reduxTypes";
import { LoginState } from "../../types/state.types";

function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { userData, modalOpen } = useSelector<StoreState, LoginState>(
    (state) => state.loginState
  );
  const [cpfInput, setCpfInput] = useState<string>("");
  const [senhaInput, setSenhaInput] = useState<string>("");

  const onChangeCpf = (value: string) => {
    setCpfInput(value);
  };

  const onChangeSenha = (value: string) => {
    setSenhaInput(value);
  };

  const realizarLogin: React.FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();

    if (validarLogin()) {
      return dispatch(loginActions.login(cpfInput, senhaInput));
    }
  };

  const validarLogin: () => boolean = () => {
    let loginValido = true;
    if (cpfInput.length !== 11) {
      loginValido = false;
      message.error("Informe um CPF válido!");
    }
    if (senhaInput.length < 3) {
      loginValido = false;
      message.error("Informe uma Senha válida!");
    }
    return loginValido;
  };

  const cancelarModalLGPD = () => {
    dispatch(loginActions.setModalOpen(false));
    dispatch(loginActions.setTempSession(undefined));
    message.error("Termos de uso não aceitos!");
  };
  const aceitarModalLGPD = () => dispatch(loginActions.aceitarLGPD(cpfInput));

  const possuiPreCadastro = useMemo(() => {
    const configPreCadastro = getSessionConfig().Configuracoes?.find(
      (c) => c.ID === ConfigsSet.PreCadastro
    );
    return configPreCadastro ? configPreCadastro.Valor === "1" : false;
  }, []);

  return (
    <LoginWrapper>
      <PageTitle titulo="Área Restrita - Login" centralizado />

      <LoginForm onSubmit={realizarLogin}>
        <InputLabel
          labelText="CPF"
          labelId="cpf"
          type="number"
          value={cpfInput}
          onChange={onChangeCpf}
          required
          column
        />
        <InputLabel
          labelText="Senha"
          labelId="senha"
          type="password"
          value={senhaInput}
          onChange={onChangeSenha}
          required
          column
        />

        <Button primary type="submit">
          Acessar
        </Button>
      </LoginForm>

      <LinkSecundario>
        Não possui ou esqueceu a senha?&nbsp;
        <Button
          textButton
          onClick={(e) => {
            e.preventDefault();
            navigate(routes.RecuperacaoSenha);
          }}
        >
          Obter senha
        </Button>
      </LinkSecundario>
      {possuiPreCadastro && (
        <LinkSecundario>
          Deseja se Cadastrar?&nbsp;
          <Button
            textButton
            onClick={(e) => {
              e.preventDefault();
              navigate(routes.PreCadastro);
            }}
          >
            Pré-cadastro
          </Button>
        </LinkSecundario>
      )}

      <ModalLGPD
        text={
          userData
            ? userData.MensagemConsentimentoLGPD?.replaceAll("\n", "<br>") ?? ""
            : ""
        }
        login={cpfInput}
        isOpen={modalOpen}
        onOk={aceitarModalLGPD}
        onCancel={cancelarModalLGPD}
      />
    </LoginWrapper>
  );
}

export default Login;
